import { getUniverseId } from "@/util";

export default () => ({
    universe: {},
    universe_id: getUniverseId(),
    affiliation_reset_cache: false,
    affiliation_refresh_next_page: false
});
